export const SHORT_MESSAGE_FORMATTING_TOOLBAR = {
  // BOLD: { key: 'BOLD', value: 'Bold' },
  // ITALIC: { key: 'ITALIC', value: 'Italic' },
  // UNDERLINE: { key: 'UNDERLINE', value: 'Underline' },
  // SPACING: { key: 'UNDERLINE', value: 'Spacing' },
  // LIST: { key: 'LIST', value: 'List' },
  LINK_TOOLTIP: { key: 'LINK', value: 'Link' },
  SEND_FOR_TESTING_TOOLTIP: { key: 'SEND_FOR_TESTING_TOOLTIP', value: 'Send for Testing' },
  SEND_FOR_TESTING_BUTTON: { key: 'SEND_FOR_TESTING_BUTTON', value: 'Send for Testing' },
  ENVS_BUTTON: { key: 'ENVS_BUTTON', value: 'Envs' },
  ENVS_TOOLTIP: { key: 'ENVS_TOOLTIP', value: 'View Test, Prod Versions' },
  VERSION_TOOLTIP: { key: 'VERSION_TOOLTIP', value: 'Version' },
};
